import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/pages/home'
import shop2 from '@/components/pages/shop2'
import productDetail from '@/components/pages/productDetail'
import standard from '@/components/pages/standard'
import stylePage from '@/components/pages/style'
import styleSearchPage from '@/components/pages/styleSearch'
import designer from '@/components/pages/designer'
import designerItem from '@/components/pages/designerItem'
import modifyEnroll from '@/components/pages/modifyEnroll'
import accountdata from '@/components/accountdata'
import changePassword from '@/components/changepassword'
import loading from '@/components/pages/loading'
import serviceterm from '@/components/pages/serviceterm'
import privacyterm from '@/components/pages/privacyterm'
import aboutYFP from '@/components/pages/aboutYFP'
import contactus from '@/components/contactus'
import dedicatedService from '@/components/dedicatedService'
import workslayout from '@/components/workslayout'
import serviceContent from '@/components/pages/serviceContent'
import aboutMember from '@/components/aboutMember'
import buyAndTake from '@/components/buyAndTake'
import invoiceAndSaledService from '@/components/invoiceAndSaledService'
import einvoice from '@/components/einvoice'
import teachEdit from '@/components/teachEdit'
import homeSwipertest from '@/components/homeSwipertest'
import activity from '@/components/pages/activity'
import activityTest from '@/components/pages/activityTest'
import invoice from '@/components/pages/invoice'
import invoiceSearch from '@/components/invoiceSearch'
import invoiceCarrier from '@/components/pages/invoiceCarrier'
import carrierBelong from '@/components/carrierBelong'
import paperMaterial from '@/components/pages/paperMaterial'
import exchange from '@/components/pages/exchange'
import bakeTaiwan from '@/components/pages/exchangeBakeTaiwan'
import test from '@/components/test'
// import Lottery from '@/components/pages/lottery'
import upload from '@/components/pages/upload'
import orderContent from '@/components/orderContent'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/shop2',
      name: 'shop2',
      component: shop2
    },
    {
      path: '/homeswipertest',
      name: 'swipertest',
      component: homeSwipertest
    },
    {
      path: '/productDetail/:id',
      name: 'productDetail',
      component: productDetail
    },
    {
      path: '/:shop/standard/:id',
      name: 'shopstandard',
      component: standard
    },
    {
      path: '/standard/:id',
      name: 'standard',
      component: standard
    },
    {
      path: '/stylePage/:id/:specid/:sizeid/:styleId',
      name: 'stylePage',
      component: stylePage
    },
    {
      path: '/styleSearchPage/:id/:specid/:sizeid',
      name: 'styleSearchPage',
      component: styleSearchPage
    },
    {
      path: '/:shop/designer/:id/:designerId',
      name: 'shopdesigner',
      component: designer
    },
    {
      path: '/brand/isabelle',
      redirect: '/designer/702/702'
    },
    {
      path: '/designer/:id/:designerId',
      name: 'designer',
      component: designer
    },
    {
      path: '/designerItem/:designerItemId',
      name: 'designerItem',
      component: designerItem
    },
    {
      path: '/serviceterm',
      name: 'serviceterm',
      component: serviceterm
    },
    {
      path: '/privacyterm',
      name: 'privacyterm',
      component: privacyterm
    },
    {
      path: '/aboutYFP',
      name: 'aboutYFP',
      component: aboutYFP
    },
    {
      path: '/serviceContent',
      name: '',
      component: serviceContent,
      children: [
        {
          path: '',
          name: 'teachEdit',
          component: teachEdit
        },
        {
          path: 'contactus',
          name: 'contactus',
          component: contactus
        },
        {
          path: 'workslayout',
          name: 'workslayout',
          component: workslayout
        },
        {
          path: 'aboutMember',
          name: 'aboutMember',
          component: aboutMember
        },
        {
          path: 'buyAndTake',
          name: 'buyAndTake',
          component: buyAndTake
        },
        {
          path: 'invoiceAndSaledService',
          name: 'invoiceAndSaledService',
          component: invoiceAndSaledService
        },
        {
          path: 'einvoice',
          name: 'einvoice',
          component: einvoice
        }
      ]
    },
    {
      path: '/dedicatedService',
      name: 'dedicatedService',
      component: dedicatedService
    },
    {
      path: '/invoice',
      name: '',
      component: invoice,
      children: [
        {
          path: '',
          name: 'invoiceSearch',
          component: invoiceSearch
        }
      ]
    },
    {
      path: '/invoiceCarrier',
      name: '',
      component: invoiceCarrier,
      children: [
        {
          path: '',
          name: 'carrierBelong',
          component: carrierBelong
        }
      ]
    },
    {
      path: '/activity/:id',
      name: 'activity',
      component: activity
    },
    {
      path: '/activity/2023newyear',
      name: 'activity2023newyear',
      component: activity
    },
    {
      path: '/actTest',
      name: 'activityTest',
      component: activityTest
    },
    {
      path: '/modifyEnroll',
      name: '',
      component: modifyEnroll,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'products',
          component: accountdata,
          meta: { requiresAuth: true }
        },
        {
          path: 'changePassword',
          name: 'changePassword',
          component: changePassword
        }
      ]
    },
    {
      path: '/loading',
      name: loading,
      component: loading
    },
    {
      path: '/paperMaterial',
      name: 'paperMaterial',
      component: paperMaterial
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: exchange
    },
    // 20240617 add
    {
      path: '/order/bake-taiwan',
      name: 'bakeTaiwan',
      component: bakeTaiwan
    },
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/upload',
      name: '',
      component: upload,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'orderid',
          name: 'orderContent',
          component: orderContent
        }
      ]
    }
    /*,
    {
      path: '/lottery',
      name: 'lottery',
      component: Lottery
    }
    */

  ],
  // TODO scrollBtn
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js